import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "smlouva",
  kodKey: "cislo"
});
